import React from 'react'

const Letter = () => {
    return (
        <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H14C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V10C16 10.5304 15.7893 11.0391 15.4142 11.4142C15.0391 11.7893 14.5304 12 14 12H2C1.46957 12 0.960859 11.7893 0.585786 11.4142C0.210714 11.0391 0 10.5304 0 10V2ZM2 1C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V2.217L8 6.417L15 2.217V2C15 1.73478 14.8946 1.48043 14.7071 1.29289C14.5196 1.10536 14.2652 1 14 1H2ZM15 3.383L10.242 6.238L15 9.114V3.384V3.383ZM14.966 10.261L9.271 6.82L8 7.583L6.728 6.82L1.034 10.26C1.0912 10.4724 1.21685 10.6601 1.39149 10.7938C1.56613 10.9276 1.78001 11.0001 2 11H14C14.2199 11.0001 14.4336 10.9278 14.6083 10.7942C14.7829 10.6607 14.9086 10.4732 14.966 10.261ZM1 9.114L5.758 6.238L1 3.383V9.113V9.114Z"
                fill="black"
            />
        </svg>

    )
}

export default Letter;